import api from "../../utils/api";

export function normalizeTicket(raw) {
  return {
    id: raw.id,
    subject: raw.subject || "",
    category: raw.category || "support",
    status: raw.status || "open",
    createdAt: raw.created_at || null,
    updatedAt: raw.updated_at || null,
    messages: (raw.messages || []).map((m) => ({
      id: m.id,
      body: m.body || "",
      isFromAdmin: Boolean(m.is_from_admin),
      authorName: m.author_name || null,
      createdAt: m.created_at || null,
    })),
    submitter: raw.submitter
      ? {
          id: raw.submitter.id,
          fullName: raw.submitter.full_name || "",
          email: raw.submitter.email || "",
          companyName: raw.submitter.company_name || "",
          accountStatus: raw.submitter.account_status || "unpaid",
        }
      : null,
  };
}

/** Client: list own tickets (threads included). */
export async function fetchMyTickets() {
  const data = await api.get("/api/support/tickets/", { auth: true });
  return (Array.isArray(data) ? data : []).map(normalizeTicket);
}

/** Client: create a ticket (category: "support" | "feedback"). */
export async function createTicket({ subject, message, category = "support" }) {
  const data = await api.post(
    "/api/support/tickets/",
    { subject, message, category },
    { auth: true }
  );
  return normalizeTicket(data);
}

/** Client: follow-up reply on own ticket. */
export async function replyToTicket(ticketId, message) {
  const data = await api.post(
    `/api/support/tickets/${ticketId}/reply/`,
    { message },
    { auth: true }
  );
  return normalizeTicket(data);
}

/** Admin: list all tickets, optionally filtered. */
export async function fetchAdminTickets({ status, category, search, page } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (category) params.set("category", category);
  if (search) params.set("search", search);
  if (page) params.set("page", String(page));
  const qs = params.toString();
  const data = await api.get(
    `/api/admin/support/tickets/${qs ? `?${qs}` : ""}`,
    { auth: true }
  );
  return {
    count: data.count ?? 0,
    results: (data.results || []).map(normalizeTicket),
  };
}

/** Admin: reply to any ticket. */
export async function adminReplyToTicket(ticketId, message) {
  const data = await api.post(
    `/api/admin/support/tickets/${ticketId}/reply/`,
    { message },
    { auth: true }
  );
  return normalizeTicket(data);
}

/** Admin: set ticket status (open/answered/closed). */
export async function adminSetTicketStatus(ticketId, status) {
  const data = await api.patch(
    `/api/admin/support/tickets/${ticketId}/status/`,
    { status },
    { auth: true }
  );
  return normalizeTicket(data);
}
